import { Responsive } from '@cian/ui-kit';
import { FC } from 'react';

import { Button } from 'shared/components/Button';

import { appsButtons } from './constants';

interface IButtonsGroupContainerProps {
  url: string;
  onClick: (buttonName: string) => void;
}

export const ButtonsGroupContainer: FC<IButtonsGroupContainerProps> = ({ url, onClick }) => {
  return (
    <Responsive phone>
      {appsButtons.map(item => (
        <Button key={item.name} {...item} url={url} onClick={onClick} />
      ))}
    </Responsive>
  );
};
